<p-card>

    <div class="grid">
        <div class="col-12 md:col-12 lg:col-12 breadcrumbrightmenu flex align-items-right">
            <div class="flex align-items-right" style="margin-left: auto;margin-right: 0;">
                <button pButton style="padding: 0.35rem !important;" type="button" icon="fa fa-plus"
                    class="dataplus p-button-sm p-button-raised mr-4" pTooltip="Add Invalid File Extension"
                    tooltipPosition="bottom" (click)="show('Add Invalid File Extension','')"></button>
                <button pTooltip="Help" tooltipPosition="left" aria-hidden="true" class="fa fa-question helpicon"
                    (click)="helpservice.openhelpmodal(ref, dialogService, 'Help', 1)">
                </button>
            </div>
        </div>
    </div>


    <div class="mr-0" *ngIf="datalistarray.length>0">

        <p-table #dt [value]="datalistarray" [rows]="rows2" [scrollable]="true" scrollDirection="horizontal"
            scrollHeight="{{commonScrollHeight}}"
            [globalFilterFields]="['id','source','fileextension','createdby','createdon','status']"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" sortField="fileextension"
            [rowsPerPageOptions]="paginatorArray" dataKey="id" [resizableColumns]="true" columnResizeMode="expand"
            [rowHover]="true" [showCurrentPageReport]="true" paginatorLocale="fa-IR"
            [paginator]="datalistarray.length>-1" responsiveLayout="scroll" sortMode="multiple"
            [multiSortMeta]="multiSortMeta" (onPage)="handlePageChange($event)">
            <!-- search -->

            <ng-template pTemplate="caption">
                <div class="grid">
                    <div class="col-3">&nbsp;</div>
                    <div class="col-6">
                        <span class=" p-input-icon-lft"><i icon="pi pi-search"></i>
                            <input class="form-control" pInputText type="text" id="tablesearch"
                                (input)="dt.filterGlobal($any($event.target).value , 'contains')"
                                placeholder="Search in Invalid File Extensions" class="tablesearch"
                                pTooltip="Enter Search Criteria" tooltipPosition="top" />
                        </span>
                    </div>
                </div>
            </ng-template>


            <ng-template pTemplate="header">
                <tr>
                    <th pResizableColumn style="padding-left: 15px !important;">Action </th>
                    <ng-container *ngFor="let col of _selectedColumns">
                        <th pResizableColumn [pSortableColumn]="col.fieldname" *ngIf="col.ischecked">{{col.headername}}
                            <p-sortIcon [field]="col.fieldname"></p-sortIcon>
                        </th>
                    </ng-container>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-data>
                <tr>
                    <td style="width: 10px !important;">
                        <div style="display: flex; gap: 0px;" *ngIf="data['orgid'] !=0">
                            <span class="actionItm" pTooltip="Modify" tooltipPosition="left"> <i class="fa fa-edit"
                                    (click)="show('Modify Invalid File Extension',data)"></i></span>
                            <span class="actionItm" pTooltip="Delete" tooltipPosition="left"> <i class="fa fa-times"
                                    style="color:red;font-weight:bolder;" (click)="delete(data.id)"></i></span>
                        </div>
                    </td>
                    <ng-container *ngFor="let col of _selectedColumns">
                        <td *ngIf="col.ischecked" [style.width]="col.width" [class]="col.class">
                            <span *ngIf="col.fieldname!=='activeflag'" pTooltip=" {{data[col.fieldname] }}">
                                {{data[col.fieldname] }}</span>
                            <span *ngIf="col.fieldname=='activeflag'">
                                <i *ngIf="data[col.fieldname]=== 'Y'" pTooltip="Active" tooltipPosition="left"
                                    class="fa fa-flag" style="color: green;"></i>
                                <i *ngIf="data[col.fieldname]!== 'Y'" pTooltip="Not Active" tooltipPosition="left"
                                    class="fa fa-flag" style="color: red;"></i>
                            </span>
                        </td>
                    </ng-container>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <div class="card" style="margin-top: -4px;" *ngIf="datalistarray.length==0">
        <p-card>
            <p style="text-align: center;">There is no Data in the Invalid File Extension Master...</p>
        </p-card>
    </div>
</p-card>